import React from 'react';
import { Col, Row } from 'antd';
import { PERMISSIONS } from 'constants/permissions';
import { Button, HasAccess, Typography } from 'components';
import { BestIcon, CheapestIcon, FastestIcon, LatestIcon, PlusIcon, TableEmptyIcon } from 'components/common/icons';
import { useSupplierOffers } from 'feature/purchaseRequestTabs/supplierOffers/useSupplierOffers';
import { AddSupplierOfferModal } from 'feature/purchaseRequestTabs/supplierOffers/addSupplierOffer';
import { useParams } from 'react-router-dom';
import { SupplierOfferCard } from 'feature/purchaseRequestTabs/supplierOffers/supplierOfferCard';
import styles from './styles.module.scss';
import { usePurchaseRequestByIdQuery } from 'api';

const { Text, Title } = Typography;

const sortMetrics = [
  {
    label: 'Latest',
    value: 'LATEST',
    icon: (checked: boolean) => <LatestIcon checked={checked} />,
  },
  {
    label: 'Best',
    value: 'BEST',
    icon: (checked: boolean) => <BestIcon checked={checked} />,
  },
  {
    label: 'Cheapest',
    value: 'CHEAPEST',
    icon: (checked: boolean) => <CheapestIcon checked={checked} />,
  },
  {
    label: 'Fastest',
    value: 'FASTEST',
    icon: (checked: boolean) => <FastestIcon checked={checked} />,
  },
];

export const SupplierOffersTab = React.memo(() => {
  const { id } = useParams() as { id: string };
  const { data: { purchaseRequest } = {} } = usePurchaseRequestByIdQuery({ id });
  const { onAddSupplierOfferModalStateChange, addSupplierOfferModalState, data, handleSortChange, sort, isLoading } =
    useSupplierOffers();
  return (
    <Row gutter={[0, 20]}>
      <Col span={24}>
        <Row justify={'space-between'}>
          <Col>
            <Row gutter={6} align={'middle'}>
              {sortMetrics.map((metric) => {
                return (
                  <Col key={metric.value}>
                    <Row
                      gutter={4}
                      align={'middle'}
                      className={`${styles.sort_item} ${sort === metric.value ? styles.selected_item : ''}`}
                      onClick={() => handleSortChange(metric.value)}
                    >
                      {metric.icon(sort === metric.value)}
                      <Col>
                        <Text className={'font-size-12 font-weight-500'}>{metric.label}</Text>
                      </Col>
                    </Row>
                  </Col>
                );
              })}
            </Row>
          </Col>
          {!purchaseRequest?.isFinalStatus && (
            <HasAccess role={PERMISSIONS.purchaseRequests.supplierOffers.write}>
              <Col>
                <Button
                  type={'primary'}
                  onClick={onAddSupplierOfferModalStateChange}
                  icon={<PlusIcon color={'#FFFFFF'} />}
                >
                  Add New
                </Button>
              </Col>
            </HasAccess>
          )}
        </Row>
      </Col>
      <Col span={24}>
        <Row gutter={[0, 16]}>
          {data.map((item: any) => (
            <SupplierOfferCard key={item.supplierOfferId} supplierOffer={item} />
          ))}
        </Row>
        {!data?.length && !isLoading && (
          <Row gutter={[0, 8]} justify={'center'} className={'margin-t-20'}>
            <TableEmptyIcon />
            <Col span={24}>
              <Title level={4} className={'font-weight-800 reset-title margin-t-4 center'}>
                No Supplier Offers
              </Title>
            </Col>
            <Col flex={'365px'} className={'center'}>
              <Text type={'secondary'}>No Supplier Offers has been added yet. Please click Add New to create one.</Text>
            </Col>
          </Row>
        )}
      </Col>
      <AddSupplierOfferModal
        id={id}
        modalState={addSupplierOfferModalState}
        onModalStateChange={onAddSupplierOfferModalStateChange}
      />
    </Row>
  );
});
